import { useStore } from 'vuex';

export default function storeController() {
  const store = useStore();
  function getData(key) {
    return store.state[key];
  }
  function getUserInfo() {
    store.dispatch('getUserInfo');
  }
  return {
    getUserInfo,
    getData,
  };
}
